import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { TreeRelatedFaultsPage, TreeRelatedFaultsPageProps } from "./TreeRelatedFaultsPage";

export const EMPTY_PAGE_CONTENT: TreeRelatedFaultsPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/outages-faults/trees";

export const TreeRelatedFaultsPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<TreeRelatedFaultsPageProps>("tree_related_faults", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <TreeRelatedFaultsPage {...routeProps} {...content} />;
};
